import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { useHistory } from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { format, addDays, isValid, parse } from 'date-fns';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import Paper from '@material-ui/core/Paper';

import { useParams } from "react-router-dom";



export default function CadastrarServicoOperacional() {

    const [loading, setLoading] = useState(true);

    const [botaoSalvarClickado, setBotaoSalvarClickado] = useState(false);

    const history = useHistory();

    const unidades = ['UNI', 'HORA', 'DIARIA', 'KM'];
    
   const periodicidades = [
   'UNICO',
   'DIARIO',
   'SEMANAL',
   'QUINZENAL',
   'MENSAL',
   'TRIMESTRAL',
   'SEMESTRAL',
   'ANUAL'
 ];
 const [descricaoItemCO, setDescricaoItemCO] = useState("");
    const [unidadeItemCO, setUnidadeItemCO] = useState("");

        const [nomeItemCO, setNomeItemCO] = useState("");

    const [periodoCO, setPeriodoCO] = useState(0);
    const [periodicidadeCO, setPeriodicidadeCO] = useState("");
    const [valorUnitarioCO, setValorUnitarioCO] = useState(0);
 
     const [fornecedores, setFornecedores] = useState([]);
     const [fornecedorSelecionado, setFornecedorSelecionado] = useState(null);

     const [valorTaxado, setValorTaxado] = useState(0.0);
      const [valorTaxadoDespesa, setValorTaxadoDespesa] = useState(0.0);
     const [valorTaxadoReceita, setValorTaxadoReceita] = useState(0.0);

     function handleSetFornecedor(fornecedor) {
         setFornecedorSelecionado(fornecedor);
     }
 

    async function listarInformacoes() {

            setLoading(true);
           
                   try {
                       const token = Cookies.get('token');
           
                       const headers = {
                           'Authorization': 'Bearer ' + token
                       }
           
             await api.get("v1/protected/fornecedores/listarTodos", {
                               headers: headers
                           }).then(function (response) {
           
                               setFornecedores(response.data);
                               setLoading(false);
           
                           });
            
                   } catch (_err) {
           
                       console.log("Erro ao listar informações: " + _err)
                       setLoading(false);
           
                   }
           


    }

    useEffect(() => {


        listarInformacoes();

    }, []);







    async function salvar() {
        setBotaoSalvarClickado(true);


        try {

            console.log("cadastrar chamado");
            

             const id_usuario_logado = parseInt(Cookies.get("id_usuario"));
            
                        const cadastro = {
                            descricao: descricaoItemCO,
                            nome: nomeItemCO,
                            fornecedor: fornecedorSelecionado,
                            unidade_medida: unidadeItemCO,
                            periodo: periodoCO,
                            periodicidade: periodicidadeCO,
                            valor_unitario: valorUnitarioCO,
                            usuario_criador: { id_usuario: id_usuario_logado },
                            valor_taxado: valorTaxado,
                            valor_taxado_despesa: valorTaxadoDespesa,
                            valor_taxado_receita: valorTaxadoReceita,
             
                        };
            

           

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

             const response = await api.post("/v1/protected/servicooperacional/cadastrar", cadastro,
                            { headers: headers });
            
                        const cadastro_salvo = response.data;
                        if (cadastro_salvo) {
  alert("Cadastro salvo")
                history.push({
                    pathname: "/gestao/operacional/servicosoperacionais/listar",
                })

                            
                                        } else {
                                            alert("Erro de Conexão, tente novamente mais tarde");
                                        }
                            


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setBotaoSalvarClickado(false);

        }



    }





   function returnDescricaoFornecedor(fornecedor) {
    let texto = "Fornecedor_ID: " + fornecedor.id_fornecedor;

    // Documento
    const documento = fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj;
    if (documento) texto += "\nCPF/CNPJ: " + documento;

    // Nome ou Nome Fantasia
    const nomeCompleto = fornecedor.tipo_fornecedor === 0 
        ? (fornecedor.nome || '') + " " + (fornecedor.sobrenome || '') 
        : fornecedor.nome_fantasia;

    if (nomeCompleto.trim()) texto += "\nNome/Nome Fantasia: " + nomeCompleto.trim();

    // Endereço
    const endereco = [];

    if (fornecedor.logradouro) endereco.push(fornecedor.logradouro);
    if (fornecedor.numero) endereco.push("Nº " + fornecedor.numero);
    if (fornecedor.bairro) endereco.push(fornecedor.bairro);
    if (fornecedor.complemento) endereco.push("Compl.: " + fornecedor.complemento);
    if (fornecedor.cidade) endereco.push(fornecedor.cidade);
    if (fornecedor.estado) endereco.push(fornecedor.estado);
    if (fornecedor.cep) endereco.push("CEP: " + fornecedor.cep);
    if (fornecedor.latitude && fornecedor.longitude) {
        endereco.push(`Latitude/Longitude: ${fornecedor.latitude}, ${fornecedor.longitude}`);
    }

    if (endereco.length > 0) {
        texto += "\nEndereço: " + endereco.join(", ");
    }

    // Site
    if (fornecedor.site) texto += "\nSite: " + fornecedor.site;

    return texto;
}

   

    return (
        <div>
            <NavegadorGestao
                Operacional={true}
                ServicosOperacionais={true}
                corFundo={'white'} travado={true} corTexto={'black'}
            />

 <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                align="flex-start"
                                item xs={12}
                                style={{ width: '100%', margin: 0, padding: 0 }}
                            >
        <a href="/gestao/operacional/servicosoperacionais/listar" style={{ fontSize: 14, color: 'black', marginRight: '5px' }}>{"< Serviços Operacionais - "}</a> 
        <a href={"/gestao/operacional/servicosoperacionais/cadastrar" } style={{ fontSize: 14, color: 'black', marginRight: '5px' }}>{"Cadastrar Serviço Operacional" }</a>


                         </Grid>          
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    item xs={12}
                >
                    <Button style={{ marginTop: 1 }}
                        variant="contained"
                        color="primary"
                        onClick={salvar}
                        disabled={botaoSalvarClickado}
                    > Salvar  </Button>
                </Grid>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :
                        <Grid
                            container
                            direction="row"
                            item xs={12}
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                        >
                            
                                  
                                         <Grid
                                                                                   container
                                                                                   direction="row"
                                                                                   justifyContent="center"
                                                                                   align="center"
                                                                                   item xs={12}
                                                                                   style={{ marginTop: 3 }}
                                                                               >
                                                                                   <Grid
                                                                                       container
                                                                                       direction="column"
                                                                                       justifyContent="center"
                                                                                       align="center"
                                                                                       item xs={8} >
                                                                                       
                                                                                         <Autocomplete
                                                                                                                                                   id="select-insumo"
                                                                                                                                                   options={fornecedores}
                                                                                                                                                   disableCloseOnSelect
                                                                                                                                                   getOptionLabel={(fornecedor) => returnDescricaoFornecedor(fornecedor).replace(/<br \/>/g, '\n')}
                                                                                                                                                   value={fornecedorSelecionado}
                                                                                                                                                   getOptionSelected={(option, value) => true}
                                                                                                                                                   onChange={(e, v) => handleSetFornecedor(v)}
                                                                                                                                                   filterOptions={(options, { inputValue }) => {
                                                                                                                                                       const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                                                                                                       return options.filter((fornecedor) => {
                                                                                                                                                           const insumoText = returnDescricaoFornecedor(fornecedor).toLowerCase();
                                                                                                                                                           return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                                                                                                       });
                                                                                                                                                   }}
                                                                                                                                                   renderInput={(params) => (
                                                                                                                                                       <TextField {...params} label=" Fornecedor " multiline minRows={2} />
                                                                                                                                                   )}
                                                                                                                                                   renderOption={(option) => (
                                                                                                                                                       <div dangerouslySetInnerHTML={{ __html: returnDescricaoFornecedor(option) }} />
                                                                                                                                                   )}
                                                                                                                                               />
                                                                                   </Grid>
                                                                               </Grid>
                                                                                   <Grid
                                                                                   container
                                                                                   direction="row"
                                                                                   justifyContent="center"
                                                                                   align="center"
                                                                                   item xs={11}
                                                                                   style={{ marginTop: 3 }}
                                                                               >
                                        <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="nomeItem"
                                                label="Nome"
                                                required
                                                id="nomeItem"
                                                value={nomeItemCO}
                                                onChange={(e) => setNomeItemCO(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>
                                       
                                        <Grid item xs={9}>
                                            <TextField
                                                variant="standard"
                                                name="descricaoItem"
                                                label="Descrição"
                                                required
                                                id="descricaoItem"
                                                value={descricaoItemCO}
                                                onChange={(e) => setDescricaoItemCO(e.target.value)}
                                                fullWidth
                                                multiline
                                                minRows={1}
                                            />
                                        </Grid>
                                               </Grid>

                                      <Grid item xs={2}>
  <FormControl variant="standard" fullWidth required>
    <InputLabel id="unidade-label">Unidade</InputLabel>
    <Select
      labelId="unidade-label"
      id="unidadeItem"
      name="unidadeItem"
      value={unidadeItemCO}
      onChange={(e) => setUnidadeItemCO(e.target.value)}
    >
      {unidades.map((item) => (
        <MenuItem key={item} value={item}>
          {item}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


                                       


                                       <Grid item xs={2}>
  <FormControl variant="standard" fullWidth required>
    <InputLabel id="periodicidade-label">Periodicidade</InputLabel>
    <Select
      labelId="periodicidade-label"
      id="periodicidade"
      name="periodicidade"
      value={periodicidadeCO}
      onChange={(e) => setPeriodicidadeCO(e.target.value)}
    >
      {periodicidades.map((item) => (
        <MenuItem key={item} value={item}>
          {item.charAt(0) + item.slice(1).toLowerCase()}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


                                        <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorUnitario"
                                                label="Valor Unitário"
                                                required
                                                id="valorUnitario"
                                                value={valorUnitarioCO}
                                                onChange={(e) => setValorUnitarioCO(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                                         

  
                                                                                   <Grid
                                                                                   container
                                                                                   direction="row"
                                                                                   justifyContent="center"
                                                                                   align="center"
                                                                                   item xs={11}
                                                                                   spacing={2}
                                                                                   style={{ marginTop: 3 }}
            
            >

                  <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTaxadoDespesa"
                                                label="Custo Unitário com taxas"
                                                required
                                                id="valorTaxadoDespesa"
                                                value={valorTaxadoDespesa}
                                                onChange={(e) => setValorTaxadoDespesa(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={3}>
  <TextField
    variant="standard"
    name="valorTaxadoReceita"
    label="Lucro Unitário com taxas"
    required
    id="valorTaxadoReceita"
    value={valorTaxadoReceita}
    onChange={(e) => {
      const valor = e.target.value;
      const match = valor.match(/^(-?\d*\.?\d{0,2})/);
      setValorTaxadoReceita(match ? match[1] : '');
    }}
    fullWidth
  />
</Grid>


   <Grid item xs={3}>
                                            <TextField
                                                variant="standard"
                                                name="valorTaxado"
                                                label="Valor Total com taxas"
                                                required
                                                id="valorTaxado"
                                                value={valorTaxado}
                                                onChange={(e) => setValorTaxado(e.target.value.replace(/^(\D*)(\d*(?:\.\d{0,2})?).*$/, '$2'))}
                                                fullWidth
                                            />
                                        </Grid>
                                    </Grid>
                                    </Grid>
 

                  



 

                }


        </div >
    );
}


